import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ITestRepository from '../../2_domain/test/iTestRepository';
import Get from '../../lib/di/get';
import { toKRString } from '../../lib/util/dateFormatter';
import promiseResolver from '../../lib/util/promiseResolver';

const today = new Date(new Date().setHours(0, 0, 0, 0));
const todayPlusOne = new Date(new Date().setDate(today.getDate() + 1));

const useNewTestController = (
  fromDate: Date | undefined,
  endDate: Date | undefined
) => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');
  const navigate = useNavigate();

  const navigateToAddTest = () => navigate(`../test/order`);
  const navigateToNewTestList = () =>
    navigate(
      `../test/check?${
        fromDate ? `from=${toKRString(fromDate)}` : `from=${toKRString(today)}`
      }${
        endDate
          ? `&end=${toKRString(endDate)}`
          : `&end=${toKRString(todayPlusOne)}`
      }`
    );

  const [newOrderCount, setNewOrderCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const loadNewOrderCount = () => {
    promiseResolver({
      promise: testRepo.getTestSummaries({
        status: 'all',
        searchText: '',
        pagination: {
          isAscending: false,
          pageNumber: 0,
          pageSize: 1,
        },
        fromDate: fromDate ?? today,
        endDate: endDate ?? todayPlusOne,
      }),
      successCallback: (data) => {
        setNewOrderCount(data.page?.totalElements ?? 0);
      },
      isLoadingCallback: setLoading,
    });
  };

  useEffect(() => {
    loadNewOrderCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, endDate]);

  return {
    newOrderCount,
    navigateToAddTest,
    navigateToNewTestList,
    loading,
  };
};

export default useNewTestController;
